import React from "react";
import { Identifiable, Project } from "@planzone/dto";

import { ZoneAvatar } from "@common/zoneAvatar";
import { Checkbox } from "../../checkbox";
import { Section } from "../../section";
import { filterSearch } from "../../utils";
import { Props } from "./types";
import { Projects } from "./projects";
import styles from "./styles.scss";

function Zone({ search, zone, projects: selectedProjects, select }: Props) {
  const isSelected =
    !!selectedProjects &&
    zone.projects.every(
      (project) => !!selectedProjects.find(({ uuid }) => uuid === project.uuid),
    );
  const selectProjects = (projects: Identifiable<Project>[]) =>
    select(selectedProjects ? [...selectedProjects, ...projects] : projects);
  const unSelectProjects = (projects: Identifiable<Project>[]) =>
    selectedProjects &&
    select(
      selectedProjects.filter(
        (project) => !projects.find(({ uuid }) => project.uuid === uuid),
      ),
    );

  return (
    <Section
      header={
        <div className={styles.header}>
          <div className={styles.icon}>
            <ZoneAvatar name={zone.name} color={zone.color} />
          </div>
          <p className={styles.name}>{zone.name}</p>
        </div>
      }
      list={
        <div className={styles.projects}>
          <Projects
            projects={filterSearch(zone.projects, search)}
            selectedProjects={selectedProjects}
            select={(project) => selectProjects([project])}
            unSelect={(project) => unSelectProjects([project])}
          />
        </div>
      }
    />
  );
}

export { Zone };
